import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';

import {
  SelectWrapper,
  OptionsWrapper,
  ButtonWrapper,
  SelectedOption,
  Option,
} from './styles';
import IconFont from '../../../../components/shared/IconFont';
import { EVENT_FRAME1_NAME } from '../../../../components/adv/Frame1Mobile';

class DateSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  componentDidMount() {
    window.addEventListener('wheel', this.closeOnScroll);
    //this.props.actions.filterDate(this.props.filterDate);
    //this.props.actions.updateLocalStorageDate(this.props.filterDate.get('value'));
  }

  componentWillUnmount() {
    window.removeEventListener('wheel', this.closeOnScroll);
    // E' necessario rimuovere tutti gli eventi al componentWillUnmount
    document.removeEventListener('click', this.hide);
  }

  closeOnScroll = () => {
    this.setState({ isOpen: false });
  };

  show = () => {
    if (!this.props.filterLive) {
      this.setState({ isOpen: true });
      document.addEventListener('click', this.hide);
    }
  };

  hide = () => {
    this.setState({ isOpen: false });
    document.removeEventListener('click', this.hide);
  };

  selectOption = (option) => {
    this.setState({
      //selected: option,
      isOpen: !this.state.isOpen,
    });
    this.props.actions.filterDate(option);
    this.props.actions.updateLocalStorageDate(option.get('value'));
    if (process.env.REACT_APP_SITE !== 'corriere' && window.omniture) {
      if (option.toJS().label === this.props.dictionary[0].label) {
        window.omniture.trkEventMc('Matchcenter filtro ieri');
      }
      if (option.toJS().label === this.props.dictionary[1].label) {
        window.omniture.trkEventMc('Matchcenter filtro oggi');
      }
      if (option.toJS().label === this.props.dictionary[2].label) {
        window.omniture.trkEventMc('Matchcenter filtro domani');
      }
    }
    document.dispatchEvent(new Event(EVENT_FRAME1_NAME));
  };

  render() {
    const { isOpen } = this.state;
    const selectOptions = fromJS(this.props.dictionary);
    const { filterDate } = this.props;
    return (
      <SelectWrapper
        filterLive={this.props.filterLive}
      >
        {filterDate &&
          <SelectedOption onClick={this.show}>
            {filterDate.get('label')}
          </SelectedOption>
        }
        <OptionsWrapper isOpen={isOpen}>
          {selectOptions && selectOptions.map((option, id) => (
            <Option
              onClick={() => this.selectOption(option)}
              key={id}
            >
              {option.get('label')}
            </Option>
          ))}
        </OptionsWrapper>
        <ButtonWrapper onClick={this.show}>
          <IconFont
            className="icon-matchcenter-arrows"
            font={16}
            color="white"
            lineHeight={1.25}
            withCursor
          />
        </ButtonWrapper>
      </SelectWrapper>
    );
  }
}
DateSelect.propTypes = {
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  filterLive: PropTypes.bool,
  filterDate: PropTypes.any,
};

export default DateSelect;
